/**
 * Tipos de complemento de endereço disponíveis para vendas CNPJ.
 */
export const TIPOS_COMPLEMENTO = [
  'Altos',
  'Andar',
  'Apartamento',
  'Armazém',
  'Arco',
  'Altura',
  'Beco',
  'Blocos',
  'Box',
  'Baixos',
  'Cais',
  'Cobertura',
  'Condomínio',
  'Chácara',
  'Conjunto',
  'Complemento',
  'Corredor',
  'Casa',
  'Caixa Postal',
  'Edifício',
  'Entrada',
  'Entrepiso',
  'Fazenda',
  'Frente',
  'Fundos',
  'Guichê',
  'Granja',
  'Galeria',
  'Garagem',
  'Hangar',
  'Quilômetro',
  'Lado',
  'Letra',
  'Loja',
  'Loteamento',
  'Lote',
  'Mezanino',
  'Pavimento',
  'Prédio',
  'Poste',
  'Piso',
  'Plataforma',
  'Portão',
  'Parada',
  'Ponte',
  'Pavilhão',
  'Próximo',
  'Quadra',
  'Recanto',
  'Saguão',
  'Sítio',
  'Sobreloja',
  'Sala',
  'Sobrado',
  'SubSolo',
  'Térreo',
  'Zona'
];

/**
 * Serializa pares { tipo, valor } em strings "Tipo Valor" (máx. 3).
 * Retorna { complemento1, complemento2, complemento3 }.
 */
export function serializarComplementosCnpj(pares) {
  const preenchidos = (pares || [])
    .filter((p) => p && String(p.tipo || '').trim() && String(p.valor || '').trim())
    .slice(0, 3)
    .map((p) => `${String(p.tipo).trim()} ${String(p.valor).trim()}`);

  return {
    complemento1: preenchidos[0] || '',
    complemento2: preenchidos[1] || '',
    complemento3: preenchidos[2] || ''
  };
}
